export const units = {
	SQM: {
		displayShortName: 'm2',
		displayLongName: 'square meters',
		id: 'SQM',
	},
	ACRES: {
		displayShortName: 'ac',
		displayLongName: 'acres',
		id: 'ACRES',
	},
	HECTARES: {
		displayShortName: 'ha',
		displayLongName: 'hectares',
		id: 'HECTARES',
	},
};

export function getUnitConversionMethod( unitsFrom, unitsTo ) {
	return `${unitsFrom}To${unitsTo}`;
}

export const conversionMethods = {
	// From SQM
	[ getUnitConversionMethod( units.SQM.id, units.SQM.id ) ]( value ) {
		return value;
	},

	[ getUnitConversionMethod( units.SQM.id, units.ACRES.id ) ]( value ) {
		return value / 4046.85642;
	},

	[ getUnitConversionMethod( units.SQM.id, units.HECTARES.id ) ]( value ) {
		return value / 10000;
	},

	// From ACRES
	[ getUnitConversionMethod( units.ACRES.id, units.ACRES.id ) ]( value ) {
		return value;
	},

	[ getUnitConversionMethod( units.ACRES.id, units.SQM.id ) ]( value ) {
		return value * 4046.85642;
	},

	[ getUnitConversionMethod( units.ACRES.id, units.HECTARES.id ) ]( value ) {
		return value * 0.404685642;
	},

	// From HECTARES
	[ getUnitConversionMethod( units.HECTARES.id, units.HECTARES.id ) ]( value ) {
		return value;
	},

	[ getUnitConversionMethod( units.HECTARES.id, units.SQM.id ) ]( value ) {
		return value * 10000;
	},

	[ getUnitConversionMethod( units.HECTARES.id, units.ACRES.id ) ]( value ) {
		return value / 0.404685642;
	},
};


export function convertWithUnits( value, unitsFrom, unitsTo ) {
	const conversionMethod = conversionMethods[ getUnitConversionMethod( unitsFrom, unitsTo ) ];

	if( typeof conversionMethod !== 'function' ) {
		throw new ReferenceError( `Invalid conversion from ${unitsFrom} to ${unitsTo}` );
	}

	return conversionMethod( value );
}

export function getPercentage( mininum, maximum, num ) {
	const min = Math.min( mininum, maximum ),
		max = Math.max( mininum, maximum ),
		total = max - min;

	return ( num / total ) * 100;
}
